import { lazy } from 'react';

// ----------------------------------------------------------------------

const TasksPage = lazy(() => import('../pages/Tasks.page'));

// ----------------------------------------------------------------------

const TasksRoutes = [
    {
        path: '/human-resources/tasks',
        element: <TasksPage />,
        layout: 'default',
        isAuthReq: true,
    },
  
];

export { TasksRoutes };
